import React from 'react'

export class Category extends React.Component {
  clicked = (event) => {
    event.preventDefault()
    window.scrollTo(0, 0)
    this.props.categoryChanged(this.props.categoryId)
  }

  render() {
    return (
      <div className='col-xs-12 col-md-6'>
        <a href={this.props.url}
          className='category-teaser'
          onClick={this.clicked}
          title={this.props.categoryTitle} >
          <span className='category-teaser-image' style={{ backgroundImage: `url('${this.props.imageUrl}')` }}></span>
          <span className='category-teaser-text'>
            { this.props.categoryTitle }
          </span>
        </a>
      </div>
    )
  }
}
